/* URL routing and tab-scoped quiz recovery. No answers or contact details in URLs. */
(function (root) {
  'use strict';
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const TTL = 24 * 60 * 60 * 1000;
  function create(win) {
    const initial = new URL(win.location.href);
    const requested = initial.searchParams.get('uuid');
    let saved = null;
    if (UUID.test(requested || '')) {
      try {
        const candidate = JSON.parse(win.sessionStorage.getItem('hmx_quiz_v3:' + requested));
        if (candidate && candidate.version === 3 && candidate.id === requested &&
            Number.isFinite(candidate.updatedAt) && Date.now() - candidate.updatedAt < TTL &&
            candidate.data && typeof candidate.data === 'object') saved = candidate;
      } catch (_) { /* Blocked/corrupt storage must not break the quiz. */ }
    }
    function makeId() {
      if (win.crypto.randomUUID) return win.crypto.randomUUID();
      const bytes = win.crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    }
    const id = saved ? requested : makeId();
    function step(value) {
      if (value === 'result') return 'result';
      return /^([1-9]|1[0-3])$/.test(String(value)) ? Number(value) : 1;
    }
    return {
      id, saved, missing: Boolean(requested && !saved),
      initialStep: saved ? step(initial.searchParams.get('step') || saved.step) : 1,
      save(data) {
        saved = { ...data, version: 3, id, updatedAt: Date.now() };
        try { win.sessionStorage.setItem('hmx_quiz_v3:' + id, JSON.stringify(saved)); } catch (_) {}
      },
      route(nextStep, replace) {
        const url = new URL(win.location.href);
        url.searchParams.set('uuid', id);
        url.searchParams.set('step', String(step(nextStep)));
        if (url.href !== win.location.href) {
          try { win.history[replace ? 'replaceState' : 'pushState']({ hairmaxQuiz: id }, '', url.href); } catch (_) {}
        }
      },
      readStep() {
        const url = new URL(win.location.href);
        return url.searchParams.get('uuid') === id ? step(url.searchParams.get('step')) : 1;
      },
      resultUrl() {
        const url = new URL(win.location.href);
        url.search = '';
        url.hash = '';
        url.searchParams.set('uuid', id);
        url.searchParams.set('step', 'result');
        return url.href;
      },
      restart() {
        try { win.sessionStorage.removeItem('hmx_quiz_v3:' + id); win.sessionStorage.removeItem('hmx_quiz_record'); } catch (_) {}
        const url = new URL(win.location.href);
        url.searchParams.delete('uuid');
        url.searchParams.delete('step');
        win.location.replace(url.href);
      }
    };
  }
  root.HairMaxQuizSession = { create };
})(window);
